import { useEffect, useRef, useContext } from "react" 
import { EditorView, basicSetup } from "codemirror"
import { EditorState } from "@codemirror/state"
import { indentUnit } from "@codemirror/language"
import { python } from "@codemirror/lang-python"

import { ReplayCodeContext } from '../context/ReplayCodeContext'

import '../../workspace/css/workspace.scss'

export default function ReplayCodeEditor() {
  const { code } = useContext(ReplayCodeContext)

  const editorRef = useRef(null)
  const viewRef = useRef(null)

  // Initialize Editor 
  useEffect(() => {
    if (!editorRef.current) return

    const state = EditorState.create({
      doc: code || "", 
      extensions: [
        basicSetup,
        python(),
        indentUnit.of("    "),
        EditorState.readOnly.of(true), 
        EditorView.editable.of(false), 
        EditorView.theme({
          "&": { height: "100%", fontSize: "14px", color: "#1f2937" },
          ".cm-content": { padding: "16px", minHeight: "100%", fontFamily: "Monaco, Menlo, monospace" },
          ".cm-editor": { height: "100%", backgroundColor: "#ffffff" },
          ".cm-scroller": { height: "100%", overflow: "auto" },
          ".cm-selectionBackground": { backgroundColor: "#e5e7eb !important" },
          ".cm-keyword": { color: "#7c3aed" }, 
          ".cm-string": { color: "#059669" },  
          ".cm-comment": { color: "#6b7280" }, 
          ".cm-number": { color: "#dc2626" },  
        }),
      ],
    })

    viewRef.current = new EditorView({
      state,
      parent: editorRef.current,
    })

    return () => {
      viewRef.current?.destroy()
    }
  }, []) 

  // Update Doc when `code` prop changes 
  useEffect(() => {
    const view = viewRef.current
    if (!view) return

    const currentDoc = view.state.doc.toString()

    if (code !== currentDoc) {
      view.dispatch({
        changes: {
          from: 0,
          to: currentDoc.length,
          insert: code || ""
        }
      })
    }
  }, [code]) 

  return (
    <div 
      className="ws-editor-container" 
      style={{ 
        pointerEvents: 'none',
        flex: 1,
        minHeight: 0
      }}
    >
      <div ref={editorRef} style={{ width: '100%', height: '100%' }} />
    </div>
  )
}